import { defineComponent as c, useSlots as m, ref as u, createElementBlock as d, openBlock as y, mergeProps as p, unref as o, createVNode as _ } from "vue";
import S from "../../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/EmptyState/empty-state.js";
import { c_empty_state__icon_Color as h } from "../../node_modules/.pnpm/@patternfly_react-tokens@6.2.2/node_modules/@patternfly/react-tokens/dist/esm/c_empty_state__icon_Color.js";
import { findChildrenVNodes as I, vnodeTypeIsComponent as P } from "../../util.js";
import { useOUIAProps as C } from "../../helpers/ouia.js";
const N = /* @__PURE__ */ c({
  name: "PfEmptyStateIcon",
  inheritAttrs: !1,
  __name: "EmptyStateIcon",
  props: {
    color: {},
    ouiaId: {},
    ouiaSafe: { type: Boolean }
  },
  setup(i) {
    const r = i, l = C({ id: r.ouiaId, safe: r.ouiaSafe }), n = m(), t = u(!1);
    function f() {
      return t.value = !1, n.default ? I(n.default()).map((e) => {
        let s = "true";
        return P(e.type) && e.type.name === "PfSpinner" && (s = "false", t.value = !0), e.props = p({
          "aria-hidden": s
        }, e.props ?? {}), e;
      }) : void 0;
    }
    return (a, e) => (y(), d("div", p(o(l), {
      class: o(S).emptyStateIcon,
      style: { [o(h).name]: t.value ? void 0 : a.color }
    }), [
      _(f)
    ], 16));
  }
});
export {
  N as default
};
